// Community module types

export enum VideoCategory {
  ACTION = 'action',
  LEVEL_UP = 'level_up',
  SOCIAL = 'social'
}

export enum EntityType {
  ACADEMY = 'academy',
  PLAYER = 'player',
  COACH = 'coach',
  SFL_USER = 'sfl_user'
}

export enum DifficultyLevel {
  BEGINNER = 'beginner',
  INTERMEDIATE = 'intermediate',
  ADVANCED = 'advanced'
}

export interface CommunityVideoMetadata {
  userId?: string;
  userName?: string;
  userProfilePic?: string;
  coachId?: string;
  basicInfo?: {
    fullName?: string;
    profilePic?: string;
    dob?: string;
    email?: string;
    sports?: string[];
    ageCategory?: string[];
    experience?: number;
    location?: string;
    certification?: string[];
  };
}

export interface CommunityVideo {
  _id: string;
  title: string;
  description: string;
  category: string;
  videoType: string;
  contentType: string;
  mediaType: string;
  contentUrl: string;
  thumbnailUrl?: string;
  isPortrait: boolean;
  metadata: CommunityVideoMetadata;
  tags: string[];
  likes: number;
  comments: number;
  shares: number;
  saves: number;
  views: number;
  status: string;
  featured: boolean;
  trendingScore?: number;
  uploadSource: string;
  uploadedBy: string;
  visibility: string;
  updatedAt: string;
  createdAt: string;
  __v: number;
  approvedAt?: string;
  approvedBy?: string;
  publishedAt?: string;
  lastTrendingUpdate?: string;
  // Level Up specific fields
  seriesId?: string;
  chapterNumber?: number;
  chapterTitle?: string;
  duration?: number; // Duration in seconds
  difficultyLevel?: string; // Difficulty level for series (beginner, intermediate, advanced)
  totalChapters?: number; // Total number of chapters in the series
}

export interface CommunityVideosResponse {
  statusCode: number;
  status: string;
  message: string;
  data: {
    videos: CommunityVideo[];
    total: number;
    page: string;
    totalPages: number;
  };
}

export enum VideoStatus {
  DRAFT = 'draft',
  PENDING_REVIEW = 'pending_review',
  PENDING_PROCESSING = 'pending_processing',
  PROCESSING = 'processing',
  SCHEDULED = 'scheduled',
  PUBLISHED = 'published',
  REJECTED = 'rejected',
  ARCHIVED = 'archived'
}

export interface CommunityVideosParams {
  page?: number;
  limit?: number;
  category?: VideoCategory;
  status?: VideoStatus | string;
  search?: string;
  tags?: string | string[];
  featured?: boolean;
  uploadedBy?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

